import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

// CSS
import './ErrorMessage.scss'

export default class ErrorMessage extends PureComponent {
  static propTypes = {
    message: PropTypes.string
  }

  render() {
    return (
      <div className="error-message">
        <i className="fa fa-exclamation-triangle" aria-hidden="true" />
        <span> {this.props.message}</span>
      </div>
    )
  }
}
